import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  FormControl,
  Grid,
  MenuItem,
  Select,
  Typography,
  CircularProgress,
} from "@mui/material";
import FormikSelectInput from "@/components/forms/FormikSelectInput";
import { Form, Formik } from "formik";
import { StyledButton } from "@/components";
import useFetchCommonData from "@/hooks/useFetchCommonData";
import FormikMonthYearPicker from "@/components/forms/FormikMonthYearPicker";
import CommonDataTable from "@/components/dataTableComponents/NewDatatable";
import moment from "moment";
import { toast } from "@/components/toastify";
import { useGetOverrideQuery, useUpdateOverrideMutation } from "@/api/services/attendanceManagement/muster/Muster";
import dayjs from "dayjs";

const BulkOverride = () => {

  const [selectedRows, setSelectedRows] = useState([]);
  const [changeValue, setChangeValue] = useState({
    selectEmployee: "",
    selectMonth: moment().format("MM-YYYY"),
  });
  const [dataTableKey, setDataTableKey] = useState(0);
  const [stateData, setStateData] = useState();
  const [rowActions1, setRowActions1] = useState({});
  const [rowActions2, setRowActions2] = useState({});

  const { data: fetchAllEmployees } = useFetchCommonData("EMPLOYEES");
  const { data: rowDetails = [], refetch } =
    useGetOverrideQuery({
      empId: changeValue?.selectEmployee,
      month: changeValue?.selectMonth,
    });
  const [updateOverride] = useUpdateOverrideMutation();
  const newRowDetails = (rowDetails && rowDetails?.data) || [];

  const empOptions =
    fetchAllEmployees &&
    fetchAllEmployees.map((item) => ({
      value: item.empId,
      label: item.employeeName,
    }));

  const rows = newRowDetails?.map((item, index) => {
    return {
      id: item.date,
      date: dayjs(item.date).format("DD MMM, YYYY") || "NA",
      shiftCode: item.shiftCode || "NA",
      fisrtIn: item.firstIn || "00:00",
      lastIn: item.lastOut || "00:00",
      session1: item.session1 || "NA",
      session2: item.session2 || "NA",

    };
  });

  useEffect(() => {
    const defaultActions1 = {};
    const defaultActions2 = {};
    rows.forEach((row) => {
      defaultActions1[row.id] = row.session1;
      defaultActions2[row.id] = row.session2;
    });
    setRowActions1(defaultActions1);
    setRowActions2(defaultActions2);
  }, [newRowDetails]);


  const columns = [
    { field: "date", headerName: "Date" },
    { field: "shiftCode", headerName: "Shift Code" },
    {
      field: "fisrtIn", headerName: "First In",
      renderCell: (params) => {
        const row = params.row;
        return (
          <Box display="flex" flexDirection="column">
            <Typography variant="body3">{row?.date}</Typography>
            <Typography variant="body3">{row?.fisrtIn}</Typography>
          </Box>
        );
      }
    },
    {
      field: "lastIn", headerName: "Last In",
      renderCell: (params) => {
        const row = params.row;
        return (
          <Box display="flex" flexDirection="column">
            <Typography variant="body3">{row?.date}</Typography>
            <Typography variant="body3">{row?.lastIn}</Typography>
          </Box>
        );
      }
    },
    {
      field: "session1",
      headerName: "Session 1",
      flex: 4,
      minWidth: 200,
      renderCell: (params) => {
        const row = params.row;
        const currentValue = row.session1;

        return (
          <FormControl fullWidth size="small" sx={{ width: "50%" }}>
            <Select
              value={rowActions1[row.id]?.newSession || currentValue || ""}
              onChange={(e) => {
                setRowActions1((prev) => ({
                  ...prev,
                  [row.id]: {
                    oldSession: currentValue,
                    newSession: e.target.value,
                  },
                }));
              }}
            >
              {currentValue !== "A" && currentValue !== "P" && (
                <MenuItem value={currentValue}>{currentValue}</MenuItem>
              )}
              <MenuItem value="P">P</MenuItem>
              <MenuItem value="A">A</MenuItem>
              <MenuItem value="WFH">WFH</MenuItem>
              <MenuItem value="OD">OD</MenuItem>
            </Select>
          </FormControl>
        );
      },
    },

    {
      field: "session2",
      headerName: "Session 2",
      flex: 4,
      minWidth: 200,
      renderCell: (params) => {
        const row = params.row;
        const currentValue = row.session2;
        return (
          <>
            <FormControl fullWidth size="small" sx={{ width: "50%" }}>
              <Select
                value={rowActions2[row.id]?.newSession || currentValue || ""}
                onChange={(e) => {
                  setRowActions2((prev) => ({
                    ...prev,
                    [row.id]: {
                      oldSession: currentValue,
                      newSession: e.target.value,
                    },
                  }));
                }}
              >
                {currentValue !== "A" && currentValue !== "P" && (
                  <MenuItem value={currentValue}>{currentValue}</MenuItem>
                )}
                <MenuItem value="P">P</MenuItem>
                <MenuItem value="A">A</MenuItem>
                <MenuItem value="WFH">WFH</MenuItem>
                <MenuItem value="OD">OD</MenuItem>
              </Select>
            </FormControl>

          </>
        );
      },
    },

  ];


  const handleReset = (resetForm) => {
    resetForm({
      values: {
        selectMonth: dayjs(),
        selectEmployee: "",
      },
    });
  };

  useEffect(() => {
    if (changeValue?.selectMonth && changeValue?.selectEmployee) {
      refetch();
    }
  }, [changeValue, refetch]);
  useEffect(() => {
    if (rowDetails) {
      setStateData(rowDetails);
      setDataTableKey((prev) => prev + 1);
    }
  }, [rowDetails]);

  const handleSelectedRows = (selectedData) => {
    setSelectedRows(selectedData);
  };


  const handleSubmit = async () => {
    if (selectedRows.length === 0) {
      toast("error", "Please select at least one row.");
      return;
    }

    const overrideList = selectedRows.map((rowId) => {
      const row = rows.find((r) => r.id === rowId?.id);

      return {
        date: row?.id,
        session1: {
          newSession: rowActions1[row?.id]?.newSession ||  row.session1,
          oldSession: rowActions1[row?.id]?.oldSession ||  row.session1
        },
        session2: {
          newSession: rowActions2[row?.id]?.newSession ||  row.session2,
          oldSession: rowActions2[row?.id]?.oldSession ||  row.session1
        }
      };
    });

    const firstRow = rows.find((r) => r.id === selectedRows[0]);
    const formattedMonth = moment(firstRow?.id).format("MM-YYYY");

    const payload = {
      empId: changeValue?.selectEmployee,
      monthYear: formattedMonth,
      overrideList,
    };

    try {

      await updateOverride({ formData: payload }).unwrap();
      toast("success", "Override Updated Successfully!");
      await refetch();
      setSelectedRows([]);
      handleSelectedRows([]);
    } catch (error) {
      console.error(error);
    }
  };


  return (
    <Box>

      <Formik
        initialValues={{
          selectEmployee: "",
          selectMonth: dayjs(),
        }}
        onSubmit={(values) => { }}
      >
        {({ resetForm, values, isSubmitting }) => {
          const formattedMonth = values.selectMonth
            ? moment(values.selectMonth).format('MM-YYYY')
            : "";
          useEffect(() => {
            setChangeValue({
              ...values,
              selectMonth: formattedMonth,
            });
          }, [values, formattedMonth]);
          return (
            <Form>
              <Grid container spacing={2} marginBottom={2}>
                <Grid item xs={12} sm={4}>
                  <FormikSelectInput
                    name="selectEmployee"
                    label="Select Employee"
                    required
                    placeholder="Select Employee"
                    options={empOptions}
                    search={true}
                    rows={1.5}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FormikMonthYearPicker
                    name="selectMonth"
                    label="Select Month"
                    required
                    pickerType="month"
                    placeholder="Select To Month"
                    rows={1.5}
                    maxDate={new Date()}
                  />
                </Grid>

                <Grid
                  item
                  xs={12}
                  sm={4}
                  mt={3.5}
                  sx={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <Button
                    sx={{
                      width: "100px",
                      height: "40px",
                      mr: 2,
                    }}
                    variant="outlined"
                    color="error"
                    size="medium"
                    onClick={() => handleReset(resetForm)}
                  >
                    Reset
                  </Button>
                  {selectedRows.length > 0 && (
                    <StyledButton
                      sx={{
                        width: "100px",
                        height: "40px",
                        mr: 2,
                      }}
                      variant="contained"
                      onClick={handleSubmit}
                      type="button"
                      // label={"Submit"}
                      label={isSubmitting ? <CircularProgress size={24} color="inherit" /> : "Submit"}
                    />
                  )}
                </Grid>


              </Grid>
            </Form>
          );
        }}
      </Formik>

      <CommonDataTable
        columns={columns}
        rows={rows}
        checkbox={true}
        search={false}
        disableRowSelectionOnClick={true}
        selectedRows={selectedRows}
        onSelectedRowsChange={handleSelectedRows}
      />


    </Box>
  );
};

export default BulkOverride;
